module.exports = __webpack_public_path__ + "src/assets/games/41/lily0018.jpg";